import { motion } from "framer-motion";
import { Star, Quote } from "lucide-react";
import { useApp } from "../context/AppContext";
import { useTranslation } from "../i18n";

const REVIEWS = [
  {
    name: "Alejandro",
    rating: 5,
    when_es: "Hace 10 meses",
    when_en: "10 months ago",
    text_es: "Sitio muy chulo con comida asiática de verdad. Probamos varios platos y todos estaban súper sabrosos. El ambiente es tranquilo y el personal, muy majo. Repetiría sin pensarlo.",
    text_en: "Very cool place with real Asian food. We tried several dishes and they were all super tasty. The atmosphere is quiet and the staff very kind. I would repeat without thinking twice.",
  },
  {
    name: "Vallhon",
    rating: 5,
    when_es: "Hace 4 meses",
    when_en: "4 months ago",
    text_es: "Yo creo que ha sido de los mejores restaurantes chinos que hemos ido en bastante tiempo. Una grata sorpresa, todo delicioso y la atención impecable.",
    text_en: "I think it has been one of the best Chinese restaurants we've been to in a while. A pleasant surprise — everything delicious and impeccable service.",
  },
  {
    name: "Jose Manuel Iriarte",
    rating: 5,
    when_es: "Hace 2 semanas",
    when_en: "2 weeks ago",
    text_es: "Excelente relación calidad-precio. De los pocos restaurantes chinos fuera de Usera de los que se pueda decir lo mismo. La comida muy buena y la dueña un encanto.",
    text_en: "Excellent value for money. One of the few Chinese restaurants outside Usera you can say the same about. Very good food and the owner is a delight.",
  },
  {
    name: "Vanessa C.",
    rating: 5,
    when_es: "Hace 7 meses",
    when_en: "7 months ago",
    text_es: "Pedimos 2 tipos de Ramen, Arroz 3 delicias, ternera en salsa de ostras, pescado rebozado y de postre mochi de tarta de queso y de mango. Platos abundantes y nada grasientos. Encantados.",
    text_en: "We had 2 types of Ramen, 3 Delights Rice, beef in oyster sauce, battered fish and cheesecake & mango mochi for dessert. Generous and not greasy. Delighted.",
  },
  {
    name: "María L.",
    rating: 5,
    when_es: "Hace 3 meses",
    when_en: "3 months ago",
    text_es: "La comida está deliciosa, con sabores auténticos y raciones generosas. Las gyozas de verdura impresionantes y el pollo agridulce que repito fijo.",
    text_en: "The food is delicious, with authentic flavours and generous portions. The vegetable gyozas are stunning and the sweet & sour chicken — I'll definitely repeat.",
  },
];

export const Reviews = () => {
  const { lang } = useApp();
  const t = useTranslation(lang);

  return (
    <section id="reviews" data-testid="reviews-section" className="relative py-16 md:py-24 lg:py-36 bg-[#0E0E0E] overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="text-center mb-14">
          <span className="overline">{t.reviews.overline}</span>
          <h2 className="font-serif-q5 text-4xl md:text-5xl mt-3 text-white">{t.reviews.title}</h2>
          <p className="text-gold text-sm tracking-[0.2em] mt-4">{t.reviews.subtitle}</p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {REVIEWS.map((r, idx) => (
            <motion.article
              key={idx}
              data-testid={`review-card-${idx}`}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: idx * 0.08 }}
              className="relative bg-[#141414] border border-q5 p-7 hover:border-gold transition-colors duration-500"
            >
              <Quote className="text-gold/40 mb-4" size={28} />
              <div className="flex gap-0.5 mb-4">
                {Array.from({ length: r.rating }).map((_, i) => (
                  <Star key={i} size={14} className="fill-[#C5A059] text-[#C5A059]" />
                ))}
              </div>
              <p className="text-neutral-300 leading-relaxed text-[15px] mb-6 italic font-serif-q5">
                &ldquo;{lang === "es" ? r.text_es : r.text_en}&rdquo;
              </p>
              <div className="border-t border-q5 pt-4 flex items-center justify-between">
                <span className="text-white text-sm">{r.name}</span>
                <span className="text-neutral-500 text-xs">{lang === "es" ? r.when_es : r.when_en}</span>
              </div>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
};
